module.exports = __webpack_public_path__ + "img/back-ground@2x.033c6401.png";